import React from 'react';
import { Col, Container, Row } from 'react-bootstrap';
import PageHeader from '@spark/ui-components/components/BreadCrumb';
import ProgramacaoHavanCard from './components/ProgramacaoHavanCard';

const ProgramacaoHavanMain = () => (
  <Container fluid>
    <Row>
      <Col md={12}>
        <PageHeader
          title=""
          routeSegments={[
            { name: 'Início' },
            { name: 'Programação' },
            { name: 'Agendamento' }
          ]}
        />
      </Col>
    </Row>

    <Row>
      <Col md={12}>
        <ProgramacaoHavanCard />
      </Col>
    </Row>
  </Container>
);

export default ProgramacaoHavanMain;
